import endpoints from "./endpoints";
import { getJson, getJson2 } from "./Util";
import { getQuery } from "./Util";

// Uses the fetch API to obtain the next calibration barcode.
// responseToken: A calibration token returned in the response to a request to calibrate the data in the previous calibration token.
// smallBarcode: A boolean value indicating whether 
export async function fetchNextCalibrationBarcode(responseToken: any, germanPackTest: any, smallBarcode: any) {
    const json = JSON.stringify(responseToken);
    const url = endpoints.Calibration.Api.FetchNextCalibrationBarcode + (germanPackTest ? "?" + getQuery({ "germanPackTest": germanPackTest }) + (smallBarcode ? "&" + getQuery({ "smallBarcode": smallBarcode }) : "") : smallBarcode ? "?" + getQuery({ "smallBarcode": smallBarcode }) : "");
        
    return await getJson2(url, {
        method: "post",
        body: json
    });
}

// Uses the fetch API to calibrate input obtained by scanning a calibration barcode.
// responseToken: A calibration token returned in the response to a request for the next calibration token.
// dom3KeyboardEventCodeSupport: A boolean value indicating if the browser supports DOM 3 keyboardEvent code properties.
export async function fetchCalibrate(responseToken: any, germanPackTest: any, dom3KeyboardEventCodeSupport: any) {
    const json = JSON.stringify(responseToken);
    return await getJson2(
        (dom3KeyboardEventCodeSupport
            ? endpoints.Calibration.Api.FetchCalibrateForDom3KeyboardEventCodes
            : endpoints.Calibration.Api.FetchCalibrate) +
        (germanPackTest ? "?" + getQuery({ "germanPackTest": germanPackTest }) : ""), {
        method: "post",
        body: json
    });
}